import { Component } from '@angular/core';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TranslateService} from '@ngx-translate/core';
import {DialogHelper} from '../../../../../shared/helper/dialog-helper';
import {PlayerProfileHelpComponent} from '../player-profile-help.component';

@Component({
  selector: 'app-player-profile-help-dialog',
  imports: [
    PlayerProfileHelpComponent
  ],
  templateUrl: './player-profile-help-dialog.component.html',
  styleUrl: './player-profile-help-dialog.component.scss'
})
export class PlayerProfileHelpDialogComponent
{
  public static openDialog(dialogService: DialogService, translate: TranslateService): DynamicDialogRef
  {
    return dialogService.open(
      PlayerProfileHelpDialogComponent,
      DialogHelper.createBasicConfig({
        header: translate.instant('HELP_AND_CONTACT'),
        width: DialogHelper.getDialogWidth(800),
        height: '90%',
        styleClass: 'dynamicDialog'
      }));
  }
}
